"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesCard = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "title", type: "string", description: "Card's title." }),
    React.createElement(common_1.Property, { name: "color", type: "string", description: "Color shown on title's background." }),
    React.createElement(common_1.Property, { name: "image", type: "string", description: "An URL that points to an image." }))); };
exports.PropertiesCard.displayName = 'PropertiesCard';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/PropertiesCard.tsx
// module id = 645
// module chunks = 0